import { HttpMethod } from "../http-request";
import { ApiEndpointSpecification } from "./types";
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SET_IO_CONFIGURATION } from "./url-constants";

type SetIOConfigurationEndpointSpecifications = ApiEndpointSpecification;
export const SetIOConfigurationEndpointSpecification: SetIOConfigurationEndpointSpecifications = {
    url: SET_IO_CONFIGURATION,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SetIOConfigurationRequestParams',
    requestBodySchemaName: 'SetIOConfigurationRequestBody',
    okResponseSchemaName: 'SetIOConfigurationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
}

export const invokeSetIOConfiguration = Helpers.makeApiRequestFn<
    Types.SetIOConfigurationRequestParams,
    Types.SetIOConfigurationRequestBody,
    Types.SetIOConfigurationOkResponse>(SetIOConfigurationEndpointSpecification)
